module.exports = __webpack_public_path__ + "static/media/cart_icon.159dddb5.svg";